
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const ArrowUp = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <polygon transform="translate(12.700000, 12.182836) rotate(-90.000000) translate(-12.700000, -12.182836)" points="13.2746269 5 12.0104478 6.2641791 17.0671642 11.3208955 5 11.3208955 5 13.0447761 17.0671642 13.0447761 12.0104478 18.1014925 13.2746269 19.3656716 20.4 12.1253731"></polygon>
        </g>
      </g>
    </IconBase>);
};

ArrowUp.defaultProps = {
  title: 'Arrow Up',
};

export default ArrowUp;
